import { inject, Injectable } from '@angular/core';
import { ID, QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { Product, ProductPageResponse } from '../../models/product';
import { ProductState, ProductStore } from './product.store';

@Injectable({ providedIn: 'root' })
export class ProductQuery extends QueryEntity<ProductState, Product> {
  selectSearchTerm$: Observable<string>;
  selectSearchOpen$: Observable<boolean>;
  selectSearchOverview$: Observable<boolean>;
  selectSearchResults$: Observable<ID[]>;

  selectFrontpageProducts$: Observable<ID[][]>;
  selectSuggestedProducts$: Observable<ID[]>;

  pagedResponse$: Observable<ProductPageResponse>;

  selectPage$: Observable<number>;
  selectPageSize$: Observable<number>;

  constructor() {
    const store = inject(ProductStore);
    super(store);

    this.selectSearchTerm$ = this.select((state) => state.searchTerm);
    this.selectSearchOpen$ = this.select((state) => state.searchOpen);
    this.selectSearchOverview$ = this.select((state) => state.searchOverview);
    this.selectSearchResults$ = this.select((state) => state.searchResults);

    this.selectFrontpageProducts$ = this.select((state) => state.frontpageProducts);
    this.selectSuggestedProducts$ = this.select((state) => state.suggestedProducts);

    this.pagedResponse$ = this.select((state) => state.pagedResponse);

    this.selectPage$ = this.select((state) => state.page);
    this.selectPageSize$ = this.select((state) => state.pageSize);
  }

  getLoading() {
    return this.getValue().loading;
  }

  getSearchTerm() {
    return this.getValue().searchTerm;
  }

  getSearchFilters() {
    return this.getValue().searchFilters;
  }

  getSearchOverview() {
    return this.getValue().searchOverview;
  }

  getSearchResults() {
    return this.getValue().searchResults;
  }

  getFrontpageProducts() {
    return this.getValue().frontpageProducts;
  }

  getTotal() {
    return this.getValue().pagedResponse.total;
  }

  getHasMore() {
    return this.getValue().hasMore;
  }

  getPage() {
    return this.getValue().page;
  }

  getPageSize() {
    return this.getValue().pageSize;
  }

  getSearchPageSize() {
    return this.getValue().searchPageSize;
  }

  getProduct(id: number) {
    return this.getValue().entities[id];
  }
}
